import { render, staticRenderFns } from "./post-lead-table.vue?vue&type=template&id=780f52a7"
import script from "./post-lead-table.vue?vue&type=script&lang=js"
export * from "./post-lead-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports